import { useTranslation } from 'react-i18next';
import {
  trackHomePageFeaturedSearch,
  trackHomePageShowLinksToggle,
} from 'lib/Tracking';
import { colors, screen } from 'components/styles/variables';
import PropTypes from 'prop-types';

export const Link = ({ url, section, children }) => (
  <>
    <a href={url} onClick={() => trackHomePageFeaturedSearch(section, url)}>
      <h3 data-homepage-search={url}>{children}</h3>
    </a>
    <style jsx>{`
      h3 {
        margin: 0px 0px 20px 0px;
        font-size: 14px;
        font-weight: 600;
        color: ${colors.BLACK};
        cursor: pointer;
      }

      h3:hover {
        color: ${colors.ALR1};
      }

      @media screen and (min-width: ${screen.smMin}) {
        h3 {
          font-size: 14px;
        }
      }
    `}</style>
  </>
);

Link.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
};

export function Button({ onClick, expanded, section }) {
  const { t } = useTranslation();

  return (
    <button
      onClick={() => {
        onClick();
        trackHomePageShowLinksToggle(section, expanded ? 'less' : 'more');
      }}
      data-testid="button"
    >
      {expanded ? t('home.showLess') : t('home.showMore')}
      <style jsx>{`
        button {
          font-size: 16px;
          font-weight: bold;
          color: ${colors.ALR1};
          border: none;
          background: transparent;
        }

        @media screen and (min-width: ${screen.smMin}) {
          button {
            display: none;
          }
        }
      `}</style>
    </button>
  );
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  section: PropTypes.string.isRequired,
};
